import React, { useCallback, FC } from 'react';
import { InfoWindow } from "@vis.gl/react-google-maps";
import type { Supplier } from "../../../types/Supplier";
import LocationListItemMapPreview from "../../location/search/LocationListItemMapPreview";
import './LocationPreviewMarker.css';

interface ILocationPreviewMarkerProps {
  location: Supplier;
  onClick: (location: Supplier) => void;
  showVisibilityChip?: boolean;
  anchor: google.maps.marker.AdvancedMarkerElement | null | undefined;
}

const LocationPreviewMarker: FC<ILocationPreviewMarkerProps> = (props) => {
  const { location, onClick, showVisibilityChip, anchor } = props;

  const handleContentClick = useCallback(() => {
    onClick(location);
  }, [onClick, location]);

  return (
    <InfoWindow
      anchor={anchor}
      headerDisabled={true}
      shouldFocus={false}
      // MapPanController centres the pin + card instead
      disableAutoPan={true}
    >
      <div className="map-preview-wrapper">
        <LocationListItemMapPreview
          location={location}
          showVisibilityChip={!!showVisibilityChip}
          isFavorite={undefined}
          onContentClick={handleContentClick}
        />
      </div>
    </InfoWindow>
  );
}

export default LocationPreviewMarker;
